import ReactDOM from 'react-dom/client';

import { Amplify } from 'aws-amplify';

import App from './App';
import currentConfig from './aws-exports';

import './fonts.css';
import './index.css';

import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

Amplify.configure(currentConfig);

root.render(<App />);
